import React, { createContext, useContext, useState } from 'react';

const GameContext = createContext();

export const DIFFICULTY_LEVELS = {
  EASY: {
    name: 'Easy',
    initialBlur: 14,    // Slightly increased for better start visibility
    blurStep: 0.60,     // Faster reduction (14 -> 8.4 -> 5 -> 3)
    color: 'green'
  },
  MEDIUM: {
    name: 'Medium',
    initialBlur: 18,    // Moderate start blur
    blurStep: 0.65,     // Medium reduction (18 -> 11.7 -> 7.6 -> 4.9)
    color: 'yellow'
  },
  HARD: {
    name: 'Hard',
    initialBlur: 22,    // Higher initial blur
    blurStep: 0.70,     // Slower reduction (22 -> 15.4 -> 10.8 -> 7.5)
    color: 'red'
  }
};

export const GameProvider = ({ children }) => {
  const [difficulty, setDifficulty] = useState(DIFFICULTY_LEVELS.MEDIUM);

  return (
    <GameContext.Provider value={{ difficulty, setDifficulty }}>
      {children}
    </GameContext.Provider>
  );
};

export const useGame = () => useContext(GameContext); 